import SelectTable from '../../../generic/selectTable';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setApprovalKey,
  setApprovalUI,
  setGroupForDelete,
  setGroupForEdit
} from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { STEP_1 } from '../../../../redux/slices/LomavisPostApproval/constants';
import { GroupMembersTooltip } from './groupMembersTooltip';
import { formatGroups } from './utils';

const GroupSelectTable = ({ currentStep }: { currentStep?: any }) => {
  const { t } = useTranslate();

  const dispatch = useDispatch();
  const {
    data: { approval_step_2_group, approval_step_1_group, groups, status }
  } = useSelector((state: any) => state.lomavisPostApproval);

  const onEdit = (item) => {
    // first move the group to edit group in slice.
    dispatch(setGroupForEdit(item));
    dispatch(setApprovalUI({ key: 'showEditGroupModal', value: true }));
  };
  const onDelete = (item) => {
    // first move the group to edit group in slice.
    dispatch(setGroupForDelete(item));
    dispatch(
      setApprovalUI({ key: 'showDeleteConfirmationModal', value: true })
    );
  };
  const onSelect = (group: any): void => {
    if (status > 1) {
      return;
    }

    let selected = approval_step_1_group;
    let key = 'approval_step_1_group';
    if (currentStep !== STEP_1) {
      selected = approval_step_2_group;
      key = 'approval_step_2_group';
    }
    const groupData = group.data || group;
    let newSelectedGroups = null;
    if (selected?.uuid === groupData.uuid) {
      newSelectedGroups = null;
    } else {
      newSelectedGroups = groupData;
    }
    dispatch(setApprovalKey({ key, value: newSelectedGroups }));
  };

  const selectedGroup =
    currentStep === STEP_1 ? approval_step_1_group : approval_step_2_group;
  const selectedGroups = selectedGroup ? [selectedGroup] : [];

  return (
    <SelectTable
      data={formatGroups(groups, t('members'))}
      onSelect={onSelect}
      selected={selectedGroups}
      canEdit={true}
      canDelete={true}
      onEdit={onEdit}
      onDelete={onDelete}
      tooltip={(group) => <GroupMembersTooltip group={group} />}
    />
  );
};
export default GroupSelectTable;
